import React from 'react';
import { Link } from 'react-router-dom';
import PageShell from '../Components/ui/PageShell';
import { useLayout } from '../layout/AppLayout';

function UsersHub() {
  const { openFormModal } = useLayout();

  return (
    <PageShell
      title="Users"
      subtitle="Manage recruiters, team leads, and system access."
      breadcrumbs={[
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'Users' },
      ]}
      backTo="/dashboard"
    >
      <div className="hr-dashboard-grid">
        <button type="button" className="hr-dashboard-card hr-dashboard-card-btn" onClick={() => openFormModal('create-user')}>
          <h3>Create User</h3>
          <p>Add a new recruiter or team lead</p>
        </button>
        <Link to="/users/list" className="hr-dashboard-card">
          <h3>User List</h3>
          <p>View, search, import and export all users</p>
        </Link>
        <Link to="/users/list?role=User" className="hr-dashboard-card">
          <h3>Recruiters</h3>
          <p>View all recruiter accounts</p>
        </Link>
        <Link to="/users/list?role=TeamLead" className="hr-dashboard-card">
          <h3>Team Leads</h3>
          <p>Manage team lead assignments</p>
        </Link>
      </div>
    </PageShell>
  );
}

export default UsersHub;
